<template>
    <div class="feed-page-container">
        
        <CCard  bodyWrapper>
            <div class="d-flex justify-content-between  feed_page_top">
                <div class="d-flex align-items-center" style="padding-right: 5px;">
                    <CSwitch
                        shape='pill'
                        color="success"
                        class="mr-2"
                        @update:checked="followOnly = $event"
                    />
                    <span>My tipsters</span>
                    <CSwitch
                        shape='pill'
                        color="info"
                        class="mx-2"
                        @update:checked="followStrategyOnly = $event"
                    />
                    <span>My strategy</span>
                    <CSwitch
                        shape='pill'
                        color="info"
                        class="mx-2"
                        @update:checked="myLikedOnly = $event"
                    />
                    <span>My liked</span>
                    <CSwitch
                        shape='pill'
                        color="info"
                        class="mx-2"
                        @update:checked="liveOnly = $event"
                    />
                    <span>Live</span>
                </div>

                <div style="width: 100%; display: flex; justify-content: right;"><span style="font-weight: 500; margin-right: 5px; color: #fff; background-color: #007bff; border-radius: 0.25rem; padding-right: 5px; padding-left: 5px;">{{totalFeeds}}</span></div>
                <CButton color="info" shape="pill" variant="outline" @click="init">
                    {{ $t('Refresh') }}
                </CButton>
            </div>
            
            <div v-if="feed_alert" style="padding-top:  10px; padding-right: 5px; text-align: right; padding-bottom: 10px;" >
                <a style="color:  blue; padding-right: 5px;" v-b-modal.modal-center @click="callAlertSet">alert settings</a><img v-b-modal.modal-center @click="callAlertSet" style="width: 22px;" src="/img/image_2022_04_21T18_06_25_457Z.png" />
            </div>
                   
            
            <div v-if="loading" class="d-flex justify-content-center m-2 tip_body" style="height: 10px;">
                <CSpinner
                    color="info"
                    style="width:4rem;height:4rem;"
                />
            </div>
            <div v-else class="feed_page_content">
                <div :key="index" v-for="(item, index) in filteredData" class="feed_card">
                    <post-card 
                        :key="refreshKey"
                        :index="index"
                        :loading="!!cashoutQueue.find(nItem => nItem._id === item._id && nItem.cashout_type === 0)"
                        :cover_loading="!!cashoutQueue.find(nItem => nItem._id === item._id && nItem.cashout_type === 1)"
                        :item="item"
                        :handleLikeTip="handleLikeTip"
                        :handleFollowTip="handleFollowTip"
                        :handleFollowUser="handleFollowUser"
                        :handleFollowStrategy="handleFollowStrategy"
                        :handlePostComment="handlePostComment"
                        :handleSelectReply="handleSelectReply"
                        :onCashOut="handleCashOut"
                        :handleDeleteTip="handleDeleteTip"
                        :handleDeleteComment="handleDeleteComment"
                    />
                </div>
                <div v-if="pendingTips > data.length" style="text-align: center;">                    
                <!-- <div style="text-align: center;"> -->
                    <CButton color="dark" class="align-items-center" @click="loadMore(data.length)" :disabled="loadmore_loading">
                        Load more
                        <CSpinner v-if="loadmore_loading" color="danger" size="sm" />
                    </CButton>
                </div>

                <div v-if="data.length === 0" style="text-align: center;">
                    <span style="display: block; margin-bottom: 20px">{{ $t("Sorry, no tips available at the moment, please try later") }}</span>
                    <CButton color="success"@click="goToPost">
                        {{ $t("Post your tip now!") }}
                    </CButton>
                </div>
            </div>

            <b-modal id="modal-center" 
            class="live-stats-modal" 
            centered title="Telegram alert setting"
            @ok="handleOk"
            @cancel="handleCancel">
                <div v-if="!isload" style="height: 10px;">
                    <b-progress :value="current_counter" :max="counter" animated></b-progress>
                </div>
                <div v-else>
                    <div>                       
                        <div class="form-group ">
                            <label style="float: left;  margin-right: 5px;">{{ $t('Telegram user ID') }}</label>
                            <CInput  :value.sync="chatId"></CInput>
                        </div>
                        <div class="form-group ">
                            
                            <b-form-checkbox   v-model="telegramNotify" switch>
                                {{ $t('Active notification') }}
                            </b-form-checkbox>
                        </div>
                    </div>
                    <div>
                        <p style="text-align: center;">{{ $t("HOW TO RECEIVE ROBOT ALERTS") }}</p>
                        <p>1.  {{ $t("Be sure to follow the next steps using a device which has installed Telegram app. Can be any device: PC, smartphone or anything else.") }}</p>
                        <p>2.  {{ $t("To get your telegram user ID please click on the following link:") }}<br>
                        <a href="https://t.me/userinfobot" target="_blank">t.me/userinfobot</a><br>
                        {{ $t("Click on 'Send message'. Then write '/start'. You'll see your ID which is composed by 9 numbers.") }}<br>
                        {{ $t("Copy the ID number and put it in the 'telegram user ID' form above.") }}<br>
                        <span>{{ $t("Then save button below") }}</span></p>   
                        <p>3.  {{ $t("Please click on the link below to access to 'Goal Traders RoBot' and receive alerts from the robots:") }}<br>
                        <a href="https://t.me/GoalTradersRoBot" target="_blank">t.me/GoalTradersRoBot</a><br>
                        {{ $t("Then, click on 'Send message', then write '/start', alerts will come soon as they are available.") }}</p>
                        <p>4.  {{ $t("You can stop/start to receive notification at any time just turning off/on the button 'active notification' above.") }}</p>
                        <p>{{ $t("For further help please watch the video in the tutorials area:") }} <a :href="video_link" target="_blank"> tutorial area</a></p>
                    </div>
                </div>
                <template #modal-footer="{ ok, cancel, hide }">
                    <b-button size="sm" variant="success" @click="ok()">
                        {{ $t('Save') }}
                    </b-button>
                    <b-button size="sm" variant="danger" @click="cancel()">
                        {{ $t('Close') }}
                    </b-button>                    
                </template>
            </b-modal>
            
            
        </CCard>
    </div>

</template>
<script src="https://code.iconify.design/2/2.2.1/iconify.min.js"></script>
<script>

    import { mapActions, mapGetters } from 'vuex';

    import Avatar from '@/components/Avatar';
    import PostCard from '@/components/PostCard';

    import Swal from 'sweetalert2';

    import { VUE_APP_URL } from '@/config';
    import tipMixin from '@/mixins/TipMixin';
    import commonMixin from '@/mixins/common/commonMixin';
    import {convertUTCToLocal, defaultFormat} from '@/helpers/time';
    import {displaySuccess, displayError} from '@/helpers/message';

    export default {
        name: 'PostTip',
        mixins: [commonMixin, tipMixin],
        components: {
            Avatar,
            PostCard
        },
        data () {
            return {
                feed_alert: true,
                data: [],
                followOnly: false,
                followStrategyOnly: false,
                myLikedOnly: false,
                liveOnly: false,
                cashOutTimer: null,
                newcashOutTimer: null,
                refreshKey: 0,
                userId: '',
                totalFeeds: 0,
                pendingTips: 0,
                loadmore_loading: false,
                notshown_ids: [],
                telegramUser: "",
                counter: 0,
                isload: false,
                chatId: "",
                telegramNotify: false,
                video_link: 'https://sospesosoftwares.com/video-tutorials/'
            }
        },
        computed: {
            ...mapGetters(['loggedInUser']),
            ...mapGetters('notifications', {
                allInfo: 'info'
            }),
            filteredData() {
                this.refreshKey += 1;
                
                let result = this.data.slice();
                if(this.followOnly) {
                    result = result.filter(item => item.isFollowed);
                }
                if(this.followStrategyOnly) {
                    result = result.filter(item => item.strategyData && item.strategyData.followers.includes(parseInt(this.loggedInUser.user_id)));
                }
                if(this.myLikedOnly) {
                    
                    result = result.filter(item => (item.like || []).includes(parseInt(this.loggedInUser.user_id)));
                }
                if(this.liveOnly) {
                    
                    result = result.filter(item => (item.fixture[0].time.status == 'LIVE' || item.fixture[0].time.status == 'HT'));
                }

                result = Array.from(new Set(result.map(a => a._id)))
                     .map(_id => {
                       return result.find(a => a._id === _id)
                     })
                return result;
            }
        },
        methods: {
            ...mapActions([
                'getFeeds',
                'getFeeds_',
                'postComment',
                'toggleLikeTip',
                'toggleFollowTip',
                'toggleFollowUser',
                'toggleFollowStrategy',
                'getMyPendingFeeds',
                'cashOut',
                'postCashoutRef',
                'deleteTip',
                'deleteComment',
                'postAlertSet',
                'getAlertSet',
                'me'
            ]),
            set_videoLink() {
                var base_url = 'https://sospesosoftwares.com/video-tutorials/';                

                if (localStorage.getItem("user_id") == 0 ) {
                    this.feed_alert = true;
                    var lang = localStorage.getItem('lang');
                    if (lang != 'en')
                       this.video_link = base_url + '?lang=' + lang;
                    else
                       this.video_link = base_url;
                    }
                else {
                   this.me().then(data => {
                        if (data.status == "success") {
                            let userData = data.data;                          

                            if (userData.feed_alert === false)
                                this.feed_alert = false;
                            else
                                this.feed_alert = true;
                            if (userData.tutorial_url)
                                this.video_link = userData.tutorial_url;                         
                        }
                        
                        else {
                            this.$router.push("/pages/login");
                        }
                    }).catch(err => {
                        console.log("error", err)
                    });
                 }
             },
            callAlertSet(){                
                
                this.isload = false
                this.current_counter = 0
                clearInterval(this.clock)
                this.clock = setInterval(this.frame, 100)
                this.getAlertSet().then(({chatId, telegramNotify})=> {
                    if (chatId)
                        this.chatId = chatId;
                    else
                        this.chatId = "";
                    if (telegramNotify)
                        this.telegramNotify = telegramNotify;
                    else
                        this.telegramNotify = false;
                    this.isload = true;
                    this.percallfunction()
                })
            },
            handleOk(bvModalEvt) {
                bvModalEvt.preventDefault();

                if (this.chatId) {
                    let postData = {
                        chatId: this.chatId,
                        telegramNotify: this.telegramNotify
                    };
                    this.postAlertSet(postData).then(({status}) => {
                        console.log(status)
                        if (status == "success")
                            displaySuccess({message: "Successfully updated"});

                        
                    }).finally(() => {
                        console.log('final')
                    });
                    
                    // Hide the modal manually
                    // this.$nextTick(() => {
                    //     this.$bvModal.hide("modal-center");
                    // })
                }
            },
            handleCancel(bvModalEvt) {
                
                this.$nextTick(() => {
                    this.$bvModal.hide("modal-center");
                })
                
            },
            percallfunction(){
                this.current_counter = 0;                
                
            },
            goToPost() {
                let route = this.$router.resolve({name: 'Post a tip'});
                window.open(route.href, '_blank');
            },
            loadMore(numberOfItems) {
                this.loadmore_loading = true;
                
                this.getFeeds_({ num: parseInt(numberOfItems)}).then(({data: {feeds}}) => {
                    feeds.forEach(fItem => {
                        if (this.loggedInUser.user_id !=0 && fItem.strategyData && fItem.strategyData.hide === true) {
                            
                        }
                        else {
                            let fIndex = this.data.findIndex(item => item._id === fItem._id);                            
                            if (fIndex < 0)
                                this.data.push(this.makeFeed(fItem));

                        }

                        
                    });
                }).finally(() => {
                    this.loadmore_loading = false;
                });
            },
            handleDeleteTip(tip_id) {
                
                Swal
                    .fire({
                        title: "Are you sure?",
                        text: "You won't be able to revert this!",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Yes, delete it!",
                    })
                    .then((result) => {
                        if (result.value) {
                           this.deleteTip({tip_id: tip_id}).then((data) => {
                                let idx = this.data.findIndex(item => item._id === tip_id);
                                this.data.splice(idx, 1);

                                
                            }).finally(() => {
                                console.log('final');
                            });
                        }
                    });
            },
            handleDeleteComment(tip_id, comment_id) {
                
                Swal
                    .fire({
                        title: "Are you sure?",
                        text: "You won't be able to revert this!",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Yes, delete it!",
                    })
                    .then((result) => {
                        if (result.value) {
                           this.deleteComment({comment_id: comment_id}).then((data) => {
                                let idx = this.data.findIndex(item => item._id === tip_id);

                                let comment_idx = this.data[idx].comments.findIndex(item => item._id === comment_id)
                                this.data[idx].comments.splice(comment_idx, 1);

                                
                            }).finally(() => {
                                console.log('final');
                            });
                        }
                    });
            },
             sortJSON(data, key){
                return data.sort(function(a, b) {
                    var x = a[key]; var y = b[key];
                    return ((x < y) ? -1 : ((x > y) ? 1 : 0));
                });
            },
            sortJSON1(data, key){
                return data.sort(function(a, b) {
                    var x = a[key]; var y = b[key];
                    return ((x < y) ? 1 : ((x > y) ? -1 : 0));
                });
            },
            updateCashOut() {
                
                this.getMyPendingFeeds().then(({data}) => {
                    console.log(data.length)

                    data.forEach((dItem) => {
                        let fIndex = this.data.findIndex(item => item._id === dItem._id);
                        if(fIndex > -1) {
                            /** update fixture */
                            // const fixture = dItem.fixture;
                            // this.data[fIndex].fixture = [...fixture];
                            // this.data[fIndex].note = new Date().toLocaleTimeString();

                            var currentStatus = '';
                            var currentScore = '';
                            var currentPointProfit = '';
                            var currentOdd = '';
                            var currentOdd_suspended = false;
                            var cashOut = '';

                            var cover_currentPointProfit = '';
                            var cover_currentOdd = '';
                            var cover_currentOdd_suspended = false;
                            var cover_cashOut = '';
                            var cover_cashOut_flag = false;

                            var current_minute = null;

                            if (dItem.cover_predictionType && dItem.cover_stake && dItem.cover_odd)
                                cover_cashOut_flag = true;

                            if (dItem.settled === 0) {
                                const fixture = dItem.fixture;
                                const status = fixture[0].time.status;
                                const time = fixture[0].time;
                                const scores = fixture[0].scores;
                                /** get current status */
                                currentStatus = status;
                                if (status === 'LIVE' || status === 'HT') {
                                    let minute = time.minute ? `${Math.floor(time.minute / 10)}${time.minute % 10}'` : '00\'';
                                    let second = time.second ? time.second : '00';
                                    let added_time = time.added_time ? `+${time.added_time}\'` : '';
                                    currentStatus = `${time.status}  ${minute} ${second} ${added_time}`;

                                    current_minute = time.minute;
                                }
                                /** current score */
                                currentScore = `${scores.localteam_score} : ${scores.visitorteam_score}`;
                                /** get current odd */
                                let odds = [];
                                const ft_market_ids = [1, 12, 976105, 136703813, 137918022, 28077, 1256989864];
                                const ht_market_ids = [37, 31379, 975903, 976226, 31359];
                                const drawnobet_market_ids = [28082,137918013,136696391];

                                if (status === 'LIVE' || status == 'HT') {
                                    odds = fixture[0].inplayOdds.data;
                                } else if (status === 'NS') {
                                    odds = fixture[0].flatOdds.data;
                                }
                                odds
                                    .filter(item => item.bookmaker_id === 2)
                                    .forEach(oItem => {
                                        let suffix = '';
                                        if (ft_market_ids.includes(oItem.market_id))
                                            suffix = 'FT';
                                        else if (ht_market_ids.includes(oItem.market_id))
                                            suffix = 'HT';
                                        else if(oItem.market_id == 63)
                                            suffix = 'Double chance';
                                        else if (drawnobet_market_ids.includes(oItem.market_id))
                                            suffix = 'Draw no bet';
                                        (oItem.odds || oItem.values).forEach((item, index) => {
                                            let label;
                                             if (oItem.market_id == 63) {
                                                if (index == 0)
                                                    label = '1X';
                                                else if (index == 1)
                                                    label = 'X2';
                                                else
                                                    label = '12';
                                            }
                                            else if (drawnobet_market_ids.includes(oItem.market_id)) {
                                                if (index == 0)
                                                    label = 'Home';
                                                else if (index == 1)
                                                    label = 'Away';
                                            }
                                            else {
                                                if (item.label)
                                                    label = `${item.label}${item.total ? ' - ' + item.total : ''}`;
                                                else if (item.team)
                                                    label = item.team;
                                                else if (item.info) {
                                                    label = item.info;
                                                }
                                                if (label === 'Yes')
                                                    label = 'BTS';
                                                else if (label === 'No')
                                                    label = 'No BTS';
                                                if (label === '1')
                                                    label = "Home";
                                                else if (label === '2')
                                                    label = 'Away';
                                                else if (label === 'X')
                                                    label = 'Draw';
                                            }
                                            
                                            
                                            if (`${label} - ${suffix}`.trim() === dItem.predictionType) {
                                                currentOdd = parseFloat(item.value);
                                                if (oItem.suspended !== null)
                                                    currentOdd_suspended = oItem.suspended;
                                                else
                                                    currentOdd_suspended = item.suspend;
                                            }
                                            if (`${label} - ${suffix}`.trim() === dItem.cover_predictionType){
                                                cover_currentOdd = parseFloat(item.value);
                                                if (oItem.suspended !== null)
                                                    cover_currentOdd_suspended = oItem.suspended;
                                                else
                                                    cover_currentOdd_suspended = item.suspend;
                                            }

                                        });
                                    });
                                if (currentOdd) {
                                    
                                    /** cash out */
                                    cashOut = parseFloat((dItem.odd * dItem.stake / currentOdd).toFixed(2));
                                    /** current point profit */
                                    currentPointProfit = parseFloat((cashOut - dItem.stake).toFixed(2));
                                }
                                if (cover_currentOdd) {
                                    
                                    /** cash out */
                                    cover_cashOut = parseFloat((dItem.cover_odd * dItem.cover_stake / cover_currentOdd).toFixed(2));
                                    /** current point profit */
                                    cover_currentPointProfit = parseFloat((cover_cashOut - dItem.cover_stake).toFixed(2));
                                }
                            }

                            let new_item = {
                                ...this.data[fIndex],
                                ...dItem
                            }
                           
                            new_item.currentStatus = currentStatus
                            new_item.currentScore = currentScore
                            new_item.currentPointProfit = currentPointProfit
                            new_item.currentOdd = currentOdd
                            new_item.cashOut = cashOut

                            new_item.currentOdd_suspended = currentOdd_suspended
                            new_item.cover_currentOdd_suspended = cover_currentOdd_suspended

                            new_item.cover_cashOut_flag = cover_cashOut_flag
                            new_item.cover_currentPointProfit = cover_currentPointProfit
                            new_item.cover_currentOdd = cover_currentOdd
                            new_item.cover_cashOut = cover_cashOut
                            new_item.current_minute = current_minute

                            let dateTime = convertUTCToLocal(dItem.dateTime, (new Date()).getTimezoneOffset() / 60);
                            new_item['dateTime'] = defaultFormat(dateTime);
                            new_item['orig_dateTime'] = dItem.dateTime;
                            
                            this.data.splice(fIndex, 1);
                            this.data.splice(fIndex, 0, new_item);
                           
                            if (this.userId == dItem.userId){
                                if (!dItem.cashout && dItem.ref_numOfAttempt && dItem.ref_numOfAttempt > 0 && currentPointProfit !== '' && currentOdd && !currentOdd_suspended){
                                    let selections = this.cashoutQueue.filter(function(runner) {
                                        return runner._id == new_item._id && runner.auto_cashout == 'tip';
                                    });
                                    if (selections.length == 0){
                                        console.log('auto-tip cash out')
                                        this.check_autoTipCashout(new_item, fIndex);
                                    }
                                }
                                if (!dItem.cover_cashout && dItem.cover_ref_numOfAttempt && dItem.cover_ref_numOfAttempt > 0 && cover_currentPointProfit !== '' && cover_currentOdd && !cover_currentOdd_suspended) {
                                    let selections = this.cashoutQueue.filter(function(runner) {
                                        return runner._id == new_item._id && runner.auto_cashout == 'cover';
                                    });
                                    if (selections.length == 0){
                                        console.log('auto-cover cash out')
                                        this.check_autoCoverCashout(new_item, fIndex);
                                    }
                                }
                            }
                        }
                       
                    });
                    this.checkCashOut();
                    this.sortJSON1(this.data, 'orig_dateTime');
                });
            },
            checkCashOut() {
               
                for (var cIndex=0; cIndex < this.cashoutQueue.length; cIndex++) {
                    var cItem = this.cashoutQueue[cIndex];

                    if ((cItem.auto_cashout == 'tip' || cItem.auto_cashout == 'cover') && cItem.first_input ) {
                        this.cashoutQueue[cIndex].first_input = false;
                        continue;
                    }

                
                    let fIndex = this.data.findIndex(item => item._id === cItem._id);
                    
                    if(fIndex > -1) {
                        
                        // if (_data[fIndex].openComments === false) {
                        let just = this.data[fIndex];
                        
                        if ((cItem.cashout_type === 0 && cItem.currentOdd === just.currentOdd) || (cItem.cashout_type === 1 && cItem.cover_currentOdd === just.cover_currentOdd) && cItem.currentScore === just.currentScore)
                            
                        {
                            try {
                                this.cashOut(cItem).then((res) => {
                                    let temp = {
                                        ...this.data[fIndex],
                                        ...res.data
                                    }
                                   
                                    let dateTime = convertUTCToLocal(temp.dateTime, (new Date()).getTimezoneOffset() / 60);
                                    temp['dateTime'] = defaultFormat(dateTime);
                                    
                                    this.data.splice(fIndex, 1);
                                    this.data.unshift(temp);
                                    displaySuccess(res);
                                });
                            } catch(err) {
                                displayError(err);
                            } finally {
                                this.cashoutQueue.splice(cIndex, 1);
                            }
                        } else {
                            if(this.cashoutQueue.length > 0) {
                                if (cItem.auto_cashout == 'tip' || cItem.auto_cashout =='cover') {
                                    let cashout_ref = {};
                                    let cover_cashout_ref = {};

                                    if (cItem.auto_cashout == 'tip') {
                                        cashout_ref = {
                                            'ref_numOfAttempt': parseInt(cItem.ref_numOfAttempt) - 1
                                        }
                                        this.data[fIndex].ref_numOfAttempt = parseInt(cItem.ref_numOfAttempt) - 1
                                    }
                                    else {
                                        cover_cashout_ref = {
                                            'cover_ref_numOfAttempt': parseInt(cItem.cover_ref_numOfAttempt) - 1
                                        }
                                        this.data[fIndex].cover_ref_numOfAttempt = parseInt(cItem.cover_ref_numOfAttempt) - 1
                                    }

                                    this.postCashoutRef({_id: cItem._id, cashout_ref: cashout_ref, cover_cashout_ref: cover_cashout_ref}).then((data) => {
                                        console.log('=====     attempt num reduced   =====')
                                        
                                    }).finally(() => {
                                        this.cashoutQueue.splice(cIndex, 1);
                                        displayError({message: "Posting failed due to change of odds or score."});
                                    });
                                }
                                else {
                                    this.cashoutQueue.splice(cIndex, 1);
                                    displayError({message: "Posting failed due to change of odds or score."});
                                }
                            }
                        }
                        break
                    }
                    
                }
            },

            handleCashOut(tip_id, cashout_type, auto_cashout) {
                let idx = this.data.findIndex(item => item._id === tip_id);
                let cashout_item = {
                    ...this.data[idx],
                    cashout_type: cashout_type,
                    auto_cashout: auto_cashout,
                    first_input: true
                }
                this.cashoutQueue.push(cashout_item);
            },

            check_autoTipCashout(dItem, fIndex) {
                if (dItem.ref_profitPts) {
                    var val = parseFloat(dItem.ref_profitPts);
                    if (dItem.currentPointProfit >= val) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }
                }

                if (dItem.ref_profitPro) {
                    var val = parseFloat(dItem.ref_profitPro);
                    var profitPro = 100 * (dItem.currentPointProfit / dItem.stake)
                    if (profitPro >= val) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }
                }

                if (dItem.ref_stoploss) {
                    var val = -1 * parseFloat(dItem.ref_stoploss);
                    var profitPro = 100 * (dItem.currentPointProfit / dItem.stake) 
                    if (profitPro <= val) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }
                }

                if (dItem.ref_nextodd) {
                    var val = parseFloat(dItem.ref_nextodd);
                    
                    if (dItem.currentOdd && dItem.currentOdd >= val) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }
                }

                if (dItem.ref_nextodd_lower) {
                    var val = parseFloat(dItem.ref_nextodd_lower);
                    
                    if (dItem.currentOdd && dItem.currentOdd <= val) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }
                }

                if (dItem.ref_time) {
                    var val = parseFloat(dItem.ref_time);                    
                    if (dItem.current_minute && dItem.current_minute >= val) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }
                }

                if (dItem.ref_score) {
                    var old_score = dItem.ref_momnent_score;
                    var current_score = dItem.currentScore;
                    if (old_score == current_score)
                        return false;

                    var old_homeGoals = parseInt(old_score.split(':')[0].trim());
                    var old_awayGoals = parseInt(old_score.split(':')[1].trim());
                    var current_homeGoals = parseInt(current_score.split(':')[0].trim());
                    var current_awayGoals = parseInt(current_score.split(':')[1].trim());
                    var current_goals = current_homeGoals + current_awayGoals;

                    if (dItem.ref_score == 'Home' && current_homeGoals > old_homeGoals) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }

                    if (dItem.ref_score == 'Draw' && current_homeGoals === current_awayGoals) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }

                    if (dItem.ref_score == 'Away' && current_awayGoals > old_awayGoals) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }

                    if (dItem.ref_score == 'BTS' && current_homeGoals > 0 && current_awayGoals > 0) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }

                    if (dItem.ref_score == 'Over 0.5' && current_goals > 0) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }
                    if (dItem.ref_score == 'Over 1.5' && current_goals > 1) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }
                    if (dItem.ref_score == 'Over 2.5' && current_goals > 2) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }
                    if (dItem.ref_score == 'Over 3.5' && current_goals > 3) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }
                    if (dItem.ref_score == 'Over 4.5' && current_goals > 4) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }
                }
                
            },
            check_autoCoverCashout(dItem, fIndex) {
                if (dItem.cover_ref_profitPts) {
                    var val = parseFloat(dItem.cover_ref_profitPts);
                    if (dItem.cover_currentPointProfit >= val) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }
                }

                if (dItem.cover_ref_profitPro) {
                    var val = parseFloat(dItem.cover_ref_profitPro);
                    var profitPro = 100 * (dItem.cover_currentPointProfit / dItem.cover_stake)
                    if (profitPro >= val) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }
                }

                if (dItem.cover_ref_stoploss) {
                    var val = -1 * parseFloat(dItem.cover_ref_stoploss);
                    var profitPro = 100 * (dItem.cover_currentPointProfit / dItem.cover_stake) 
                    if (profitPro <= val) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }
                }

                if (dItem.cover_ref_nextodd) {
                    var val = parseFloat(dItem.cover_ref_nextodd);
                    
                    if (dItem.cover_currentOdd && dItem.cover_currentOdd >= val) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }
                }

                if (dItem.cover_ref_nextodd_lower) {
                    var val = parseFloat(dItem.cover_ref_nextodd_lower);
                    
                    if (dItem.cover_currentOdd && dItem.cover_currentOdd <= val) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }
                }

                if (dItem.cover_ref_time) {
                    var val = parseFloat(dItem.cover_ref_time);                    
                    if (dItem.current_minute && dItem.current_minute >= val) {
                        this.handleCashOut(dItem._id, 1, 'cover');

                        console.log('==========   because of time')
                        return true;
                    }
                }

                if (dItem.cover_ref_score) {
                    var old_score = dItem.ref_momnent_score;
                    var current_score = dItem.currentScore;
                    if (old_score == current_score)
                        return false;

                    var old_homeGoals = parseInt(old_score.split(':')[0].trim());
                    var old_awayGoals = parseInt(old_score.split(':')[1].trim());
                    var current_homeGoals = parseInt(current_score.split(':')[0].trim());
                    var current_awayGoals = parseInt(current_score.split(':')[1].trim());
                    var current_goals = current_homeGoals + current_awayGoals;

                    if (dItem.cover_ref_score == 'Home' && current_homeGoals > old_homeGoals) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }

                    if (dItem.cover_ref_score == 'Draw' && current_homeGoals === current_awayGoals) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }

                    if (dItem.cover_ref_score == 'Away' && current_awayGoals > old_awayGoals) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }

                    if (dItem.cover_ref_score == 'BTS' && current_homeGoals > 0 && current_awayGoals > 0) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }

                    if (dItem.cover_ref_score == 'Over 0.5' && current_goals > 0) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }
                    if (dItem.cover_ref_score == 'Over 1.5' && current_goals > 1) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }
                    if (dItem.cover_ref_score == 'Over 2.5' && current_goals > 2) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }
                    if (dItem.cover_ref_score == 'Over 3.5' && current_goals > 3) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }
                    if (dItem.cover_ref_score == 'Over 4.5' && current_goals > 4) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }
                }
                

            },

            makeFeed(fItem) {
                console.log(fItem)
                let fixture = fItem.fixture[0];
                if (fixture.stage_has_standings)
                    fItem['eventName'] = `${fixture.localTeamName} (${fixture.home_rank}) v ${fixture.visitorTeamName} (${fixture.away_rank})`;
                else
                    fItem['eventName'] = `${fixture.localTeamName} v ${fixture.visitorTeamName}`;
                let startingAt = convertUTCToLocal(fixture.time.starting_at.date_time);
                fItem['startingAt'] = startingAt.toLocaleDateString() + ' ' + startingAt.toLocaleTimeString();
                fItem['status'] = fItem.status;
                let dateTime = convertUTCToLocal(fItem.dateTime, (new Date()).getTimezoneOffset() / 60);
                fItem['dateTime'] = defaultFormat(dateTime);
                fItem['orig_dateTime'] = fItem.dateTime;
                fItem['replyTo'] = [];
                let comments = [];
                fItem.comments.forEach((cItem) => {
                    comments.push({
                        ...cItem,
                        dateTime: defaultFormat(convertUTCToLocal(cItem.dateTime, (new Date()).getTimezoneOffset() / 60)),
                        userName: cItem.user[0].alias,
                        userAvatar: `${VUE_APP_URL}/${cItem.user[0].avatar}`
                    });
                });
                let stat = fItem.stat;
                fItem = {
                    ...fItem,
                    userName: fItem.user[0].alias,
                    userAvatar: `${VUE_APP_URL}/${fItem.user[0].avatar}`,
                    comments,
                    total_tips: stat.totalCount,
                    roi:  stat.stakeTotal ? (stat.profitPTS / stat.stakeTotal * 100).toFixed(2) : 0,
                    followTip: (fItem.follow || []).includes(parseInt(this.loggedInUser.user_id)),
                    likeTip: (fItem.like || []).includes(parseInt(this.loggedInUser.user_id)),
                    followUserCount: (fItem.followingUsers || []).length,
                    openComments: false
                };

                var currentStatus = '';
                var currentScore = '';
                var currentPointProfit = '';
                var currentOdd = '';
                var currentOdd_suspended = false;
                var cashOut = '';

                var cover_currentPointProfit = '';
                var cover_currentOdd = '';
                var cover_currentOdd_suspended = false;
                var cover_cashOut = '';
                var cover_cashOut_flag = false;
                if (fItem.cover_predictionType && fItem.cover_stake && fItem.cover_odd)
                    cover_cashOut_flag = true;

                const drawnobet_market_ids = [28082,137918013,136696391];

                if (fItem.cashout) {
                    const scores = fItem.fixture[0].scores;
                    if (scores.ft_score && scores.ht_score)
                        currentStatus = `${scores.ft_score} FT(${scores.ht_score} HT)`;
                    else if (scores.ht_score)
                        currentStatus = `${scores.ht_score} HT`;
                    else
                        currentStatus = 'NS';
                } else if (fItem.settled === 0) {
                    const fixture = fItem.fixture;
                    const status = fixture[0].time.status;
                    const time = fixture[0].time;
                    const scores = fixture[0].scores;
                    /** get current status */
                    currentStatus = status;
                    if (status === 'LIVE' || status === 'HT') {
                        let minute = time.minute ? `${Math.floor(time.minute / 10)}${time.minute % 10}'` : '00\'';
                        let second = time.second ? time.second : '00';
                        let added_time = time.added_time ? `+${time.added_time}\'` : '';
                        currentStatus = `${time.status}  ${minute} ${second} ${added_time}`;
                    }
                    /** current score */
                    currentScore = `${scores.localteam_score} : ${scores.visitorteam_score}`;
                    /** get current odd */
                    let odds = [];
                    const ft_market_ids = [1, 12, 976105, 136703813, 137918022, 28077, 1256989864];
                    const ht_market_ids = [37, 31379, 975903, 976226, 31359];


                    if (status === 'LIVE' || status == 'HT') {
                        odds = fixture[0].inplayOdds.data;
                    } else if (status === 'NS') {
                        odds = fixture[0].flatOdds.data;
                    }
                    odds
                        .filter(item => item.bookmaker_id === 2)
                        .forEach(oItem => {
                            let suffix = '';
                            if (ft_market_ids.includes(oItem.market_id))
                                suffix = 'FT';
                            else if (ht_market_ids.includes(oItem.market_id))
                                suffix = 'HT';
                            else if(oItem.market_id == 63)
                                suffix = 'Double chance';
                            else if (drawnobet_market_ids.includes(oItem.market_id))
                                suffix = 'Draw no bet';
                            (oItem.odds || oItem.values).forEach((item, index) => {
                                let label;
                                if (oItem.market_id == 63) {
                                    if (index == 0)
                                        label = '1X';
                                    else if (index == 1)
                                        label = 'X2';
                                    else
                                        label = '12';
                                }
                                else if (drawnobet_market_ids.includes(oItem.market_id)) {
                                    if (index == 0)
                                        label = 'Home';
                                    else if (index == 1)
                                        label = 'Away';
                                }
                                else {
                                    if (item.label)
                                        label = `${item.label}${item.total ? ' - ' + item.total : ''}`;
                                    else if (item.team)
                                        label = item.team;
                                    else if (item.info) {
                                        label = item.info;
                                    }
                                    if (label === 'Yes')
                                        label = 'BTS';
                                    else if (label === 'No')
                                        label = 'No BTS';
                                    if (label === '1')
                                        label = "Home";
                                    else if (label === '2')
                                        label = 'Away';
                                    else if (label === 'X')
                                        label = 'Draw';
                                }
                                
                                
                                if (`${label} - ${suffix}`.trim() === fItem.predictionType){
                                    currentOdd = parseFloat(item.value);
                                    if (oItem.suspended !== null)
                                        currentOdd_suspended = oItem.suspended;
                                    else
                                        currentOdd_suspended = item.suspend;
                                }

                            });
                        });
                    if (currentOdd) {
                        
                        /** cash out */
                        cashOut = parseFloat((fItem.odd * fItem.stake / currentOdd).toFixed(2));
                        /** current point profit */
                        currentPointProfit = parseFloat((cashOut - fItem.stake).toFixed(2));
                    }
                }

                if (fItem.settled === 0 && cover_cashOut_flag) {
                    const fixture = fItem.fixture;
                    const status = fixture[0].time.status;
                    const time = fixture[0].time;
                    const scores = fixture[0].scores;
                    /** get current status */
                    currentStatus = status;
                    if (status === 'LIVE' || status === 'HT') {
                        let minute = time.minute ? `${Math.floor(time.minute / 10)}${time.minute % 10}'` : '00\'';
                        let second = time.second ? time.second : '00';
                        let added_time = time.added_time ? `+${time.added_time}\'` : '';
                        currentStatus = `${time.status}  ${minute} ${second} ${added_time}`;
                    }
                    /** current score */
                    currentScore = `${scores.localteam_score} : ${scores.visitorteam_score}`;
                    /** get current odd */
                    let odds = [];
                    const ft_market_ids = [1, 12, 976105, 136703813, 137918022, 28077, 1256989864];
                    const ht_market_ids = [37, 31379, 975903, 976226, 31359];

                    if (status === 'LIVE' || status == 'HT') {
                        odds = fixture[0].inplayOdds.data;
                    } else if (status === 'NS') {
                        odds = fixture[0].flatOdds.data;
                    }
                    odds
                        .filter(item => item.bookmaker_id === 2)
                        .forEach(oItem => {
                            let suffix = '';
                            if (ft_market_ids.includes(oItem.market_id))
                                suffix = 'FT';
                            else if (ht_market_ids.includes(oItem.market_id))
                                suffix = 'HT';
                            else if(oItem.market_id == 63)
                                suffix = 'Double chance';
                            else if (drawnobet_market_ids.includes(oItem.market_id))
                                suffix = 'Draw no bet';
                            (oItem.odds || oItem.values).forEach((item, index) => {
                                let label;
                                if (oItem.market_id == 63) {
                                    if (index == 0)
                                        label = '1X';
                                    else if (index == 1)
                                        label = 'X2';
                                    else
                                        label = '12';
                                }
                                else if (drawnobet_market_ids.includes(oItem.market_id)) {
                                    if (index == 0)
                                        label = 'Home';
                                    else if (index == 1)
                                        label = 'Away';
                                }
                                else {
                                    if (item.label)
                                        label = `${item.label}${item.total ? ' - ' + item.total : ''}`;
                                    else if (item.team)
                                        label = item.team;
                                    else if (item.info) {
                                        label = item.info;
                                    }
                                    if (label === 'Yes')
                                        label = 'BTS';
                                    else if (label === 'No')
                                        label = 'No BTS';
                                    if (label === '1')
                                        label = "Home";
                                    else if (label === '2')
                                        label = 'Away';
                                    else if (label === 'X')
                                        label = 'Draw';   
                                }
                                                             
                                
                                if (`${label} - ${suffix}`.trim() === fItem.cover_predictionType){
                                    cover_currentOdd = parseFloat(item.value);
                                    if (oItem.suspended !== null)
                                        cover_currentOdd_suspended = oItem.suspended;
                                    else
                                        cover_currentOdd_suspended = item.suspend;
                                }

                            });
                        });                   
                    if (cover_currentOdd) {
                        
                        /** cash out */
                        cover_cashOut = parseFloat((fItem.cover_odd * fItem.cover_stake / cover_currentOdd).toFixed(2));
                        /** current point profit */
                        cover_currentPointProfit = parseFloat((cover_cashOut - fItem.cover_stake).toFixed(2));
                    }
                }

                // if (fItem['cover_predictionType'] ){
                //     fItem['cover_predictionType'] = fItem['cover_predictionType'].replace('Double chance', 'DC');
                //     fItem['cover_predictionType'] = fItem['cover_predictionType'].replace('Draw no bet', 'DNB');
                // }
                // fItem['predictionType'] = fItem['predictionType'].replace('Double chance', 'DC');
                // fItem['predictionType'] = fItem['predictionType'].replace('Draw no bet', 'DNB');


                fItem = {
                    ...fItem,
                    currentStatus:  currentStatus,
                    currentScore: currentScore,
                    currentPointProfit: currentPointProfit,
                    currentOdd: currentOdd,
                    currentOdd_suspended: currentOdd_suspended,
                    cashOut: cashOut,
                    cover_currentPointProfit: cover_currentPointProfit,
                    cover_currentOdd: cover_currentOdd,
                    cover_currentOdd_suspended: cover_currentOdd_suspended,
                    cover_cashOut: cover_cashOut,
                    cover_cashOut_flag: cover_cashOut_flag
                };

                return fItem;
            },
            init() {
                this.data = [];
                this.runTimer();
                this.getFeeds().then(({data: {feeds, notshown_ids}}) => {

                    this.notshown_ids = notshown_ids;
                    feeds.forEach(fItem => {
                        if (this.loggedInUser.user_id !=0 && fItem.strategyData && fItem.strategyData.hide === true) {
                            
                        }
                        else {
                            this.data.push(this.makeFeed(fItem));
                        }
                        
                    });
                    this.runTimer(false);
                });
            },
            check_newCashouted() {
                
                
                this.getFeeds().then(({data: {feeds, notshown_ids}}) => {
                    
                    this.notshown_ids = notshown_ids;
                    feeds.forEach(fItem => {
                        if (this.loggedInUser.user_id !=0 && fItem.strategyData && fItem.strategyData.hide === true) {
                            
                        }
                        else {
                            let current_feed = this.data.filter(item => item._id == fItem._id);
                            if (current_feed.length === 0) {
                                if ((fItem.cashout !== null && fItem.cashout !== '') || (fItem.cover_cashout !== null && fItem.cover_cashout !== '')){
                                    const temp = this.makeFeed(fItem);                                    
                                    this.data.unshift(temp);
                                }
                            }
                        }
                        
                    });
                    
                });
            },
        },
        watch: {
            'allInfo.totalFeeds': {
            deep: true,
            immediate: true,
            handler(val) {
              console.log('all info =====================', val)
             
              this.totalFeeds = `${this.allInfo.totalFeeds}`
              this.pendingTips = parseInt(this.allInfo.totalFeeds)
                 
            }
          }
            
        },
        mounted() {
            let user_id = localStorage.getItem('user_id');
            this.userId = parseInt(user_id);

            this.init();
            this.sockets.subscribe('newFeed', (feed) => {
                if (this.loggedInUser.user_id !=0 && feed.strategyData && feed.strategyData.hide === true) {
                            
                }
                else {
                    let index = this.data.findIndex(dItem => dItem._id === feed._id);
                    if(index < 0) {
                        if (this.loggedInUser.user_id !=0 && feed.userId === 0)
                            feed.stat = feed.real_stat;
                        const temp = this.makeFeed(feed);
                        this.data
                            .filter(item => item.userId === feed.userId)
                            .forEach(item => item.total_tips = temp.total_tips);
                        this.data.unshift(temp);
                    }
                }

                
            });
            this.sockets.subscribe('new-comment', ({tipId, comments}) => {
                let index = this.data.findIndex(dItem => dItem._id === tipId);
                if(index > -1) {
                    this.data[index].comments = comments.map(cItem => ({
                        ...cItem,
                        dateTime: defaultFormat(convertUTCToLocal(cItem.dateTime, (new Date()).getTimezoneOffset() / 60)),
                        userName: cItem.user[0].alias,
                        userAvatar: `${cItem.user[0].avatar}`
                    }));
                }
            });
            this.sockets.subscribe('tip-settled', ({tip, stat}) => {
                this.data = this.data.filter(item => item._id !== tip._id);
                this.data
                    .filter(item => item.userId === tip.userId)
                    .forEach(item => item.roi = stat.stakeTotal ? (stat.profitPTS / stat.stakeTotal * 100).toFixed(2) : 0);
            });
            this.sockets.subscribe('UpdateUserOnlineStatus', ({onlineUsers, offlineUsers}) => {
                for (let i=0; i < this.data.length; i++) {
                    if (onlineUsers.includes(this.data[i].userId))
                        this.data[i].online = true;
                    else
                        this.data[i].online = false;
                }
            });
            /** cash out */
            this.cashOutTimer = setInterval(this.updateCashOut, 16 * 1000);
            this.newcashOutTimer = setInterval(this.check_newCashouted, 32 * 1000);
            // this.check_cashOutTimer = setInterval(this.checkCashOut, 13 * 1000);

            this.set_videoLink();
        },
        beforeDestroy() {
            this.sockets.unsubscribe('newFeed');
            this.sockets.unsubscribe('new-comment');
            clearInterval(this.cashOutTimer);
            clearInterval(this.newcashOutTimer);
            // clearInterval(this.check_cashOutTimer);
        }
    }
</script>
<style lang="scss" scoped>
    .feed_page_top{
        background-color: #f5f5f5;
        border-radius: 10px;
        border: 1px solid #d3d3d3;
        height: 70px;
        padding: 20px;
        align-items: center;
        margin-top: 15px;
    }
    .feed_page_top > button {
        border-color: #68b2fc;
        border-radius: 20px;
        /* padding: 6px; */
        color: #68b2fc;
        height: 37px;
    }
    .feed_card{
        background-color: #f5f5f5;
        border: 1px solid #d3d3d3;
        border-radius: 5px;
        padding: 20px;
        margin-bottom: 20px;
    }
   .feed-page-container {

       .header {
           .header-item {
            display: flex;
            justify-content: space-between;
            div {
                display: flex;
            }
           }
       }
       .note-box {
           position: relative;
           margin-bottom: 20px;
           .note {
               padding: 5px;
               margin: 0 0 10px;
               min-height: 70px;
               background-color: #FEE;
               border-radius: 6px;
           }
           .action-box {
               display: flex;
               .action {
                   border-radius: 5px;
                   padding: 0 5px;
                   margin-right: 10px;
                   min-width: 70px;
                   text-align: center;
                   background-color: rgba(0,0,0,0.1);
                   &.selected {
                       background-color: #39F;
                       color: #FFF;
                   }
               }
           }
       }
       .comments {
           padding: 0 0 0 40px;
           .comment {
               .comment-header {
                   display: flex;
                   align-items: center;
               }
                p {
                    padding-left: 45px;
                }
           }
       }
       .post-comment {
           text-align: right;
           .btn {
           }
       }
   }
   @media (max-width: 576px) {
       .feed_page_top{
           font-size: 10px;
       }
       .feed_page_top > button{
           font-size: 10px;
       }
       .c-switch {
            width: 39px !important;
            height: 25px !important;
            margin-left: -7px !important;
       }
    }
       
</style>
